module.exports = __webpack_public_path__ + "static/media/bank-icon-white.535c3953.svg";